const initialState = {
  requestingFetchPaymentTypes: false,
  successfulFetchPaymentTypes: false,
  errorFetchPaymentTypes: false,
  paymentTypes: [],
};

const paymentTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_PAYMENT_TYPES_REQUESTING":
      return {
        ...state,
        requestingFetchPaymentTypes: true,
        successfulFetchPaymentTypes: false,
        errorFetchPaymentTypes: false,
      };
    case "FETCH_PAYMENT_TYPES_SUCCESS":
      return {
        ...state,
        requestingFetchPaymentTypes: false,
        successfulFetchPaymentTypes: true,
        errorFetchPaymentTypes: false,
        paymentTypes: action.value,
      };
    case "FETCH_PAYMENT_TYPES_FAILURE":
      return {
        ...state,
        requestingFetchPaymentTypes: false,
        successfulFetchPaymentTypes: false,
        errorFetchPaymentTypes: true,
      };
    default:
      return state;
  }
};

export default paymentTypeReducer;
